var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 51,
    viewBox: "0 0 47 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 14.9893C24.1155 15.5239 20.7347 16.0157 18.6591 17.6408C16.2197 19.5438 15.6419 23.0292 15 30C14.3367 22.7726 13.7375 19.3086 11.0628 17.4483C8.98716 15.9943 5.62767 15.5239 0 15.0107C5.86305 14.4761 9.26534 13.9843 11.3195 12.3806C13.7803 10.4562 14.3581 6.99216 15 0C15.5991 6.43621 16.1341 9.87883 18.1241 11.8674C20.1141 13.856 23.5806 14.412 30 14.9893Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24.9964C45.0385 25.1746 43.9116 25.3386 43.2197 25.8803C42.4066 26.5146 42.214 27.6764 42 30C41.7789 27.5909 41.5792 26.4362 40.6876 25.8161C39.9957 25.3314 38.8759 25.1746 37 25.0036C38.9543 24.8254 40.0884 24.6614 40.7732 24.1269C41.5934 23.4854 41.786 22.3307 42 20C42.1997 22.1454 42.378 23.2929 43.0414 23.9558C43.7047 24.6187 44.8602 24.804 47 24.9964Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 42.9943C29.8616 43.2794 28.0585 43.5417 26.9515 44.4084C25.6505 45.4234 25.3424 47.2823 25 51C24.6462 47.1454 24.3267 45.2979 22.9001 44.3058C21.7932 43.5303 20.0014 43.2794 17 43.0057C20.127 42.7206 21.9415 42.4583 23.0371 41.603C24.3495 40.5766 24.6576 38.7292 25 35C25.3195 38.4326 25.6049 40.2687 26.6662 41.3293C27.7275 42.3899 29.5763 42.6864 33 42.9943Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/star1.de55cbcde7b5af3bf986fb342ed61522.svg";
export { ForwardRef as ReactComponent };